import '@babel/polyfill'
import "./polyfills"
import "./segment-script"
import "./hubspot-script"
import "regenerator-runtime";
import "whatwg-fetch";
// @ts-ignore
import bootstrap from "./bootstrap";
bootstrap(() => {});
